<script setup lang="ts">
import HeightExpand from '~/components/transitions/heightExpand.vue'
import VCard from '~/components/ui/VCard.vue'

import type Spacing from '~/types/spacing'

type Props = {
  modelValue: boolean
  padding: Spacing
}
type Emits = {
  'container-opening-done': []
  'container-closing-done': []
  'update:modelValue': []
}

const emit = defineEmits<Emits>()
withDefaults(defineProps<Props>(), {
  modelValue: true,
  padding: '10',
})
</script>

<template>
  <VCard class="sharedContainersToggleWrapper" :padding="padding">
    <div class="tw-relative">
      <slot class="clickWrapper tw-cursor-pointer" name="title" />
      <HeightExpand
        @done-entering="emit('container-opening-done')"
        @done-closing="emit('container-closing-done')"
      >
        <slot v-if="modelValue" name="default" />
      </HeightExpand>
      <slot name="footer" />
    </div>
  </VCard>
</template>
